import { PublicClientApplication, EventType } from "@azure/msal-browser";
import config from "libs/config";
import msalConfig from "./config";

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = { scopes: [] };

export const protectedResources = {
	graphMe: {
		endpoint: "https://graph.microsoft.com/v1.0/me",
		scopes: ["User.Read"]
	},
	samplingAPI: {
		endpoint: config.apiRoot,
		scopes: [`${config.auth.apiId}/.default`]
	}
};

export const getDefaultAccount = () => {
	const activeAccount = msalInstance.getActiveAccount();

	if (activeAccount) {
		return activeAccount;
	}

	if (msalInstance.getAllAccounts().length > 0) {
		return msalInstance.getAllAccounts()[0];
	}

	return null;
};

export const getToken = () => {
	const request = {
		account: getDefaultAccount(),
		scopes: protectedResources.samplingAPI.scopes
	};

	return msalInstance.acquireTokenSilent(request).catch(() => {
		return msalInstance.acquireTokenRedirect(request).catch(error => {
			throw error;
		});
	});
};

export const callApiWithToken = (apiEndpoint, options) => {
	const { headers } = options;

	return new Promise(resolve => {
		getToken().then(({ accessToken } = {}) => {
			options.headers = { ...headers, "Authorization": `Bearer ${accessToken}` };
			resolve(fetch(apiEndpoint, options));
		});
	});
};

export const isProtectedUrl = () => {
	const publicBase = `${window.location.origin}/public`;
	return window.location.href.indexOf(publicBase) !== 0;
};

export const initializeMsalInstance = () => {
	if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
		msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
	}

	msalInstance.enableAccountStorageEvents();

	msalInstance.addEventCallback((event) => {
		if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
			const account = event.payload.account;
			msalInstance.setActiveAccount(account);
		}
	});
};

export const isAuthenticated = () => {
	return msalInstance.getAllAccounts().length > 0;
};
